import { DataProps } from '@components/simulation/simulation-graph'

export const graphNormalize = (values: number[]): DataProps[] => {
  const months = [
    { name: 'JAN' },
    { name: 'FEV' },
    { name: 'MAR' },
    { name: 'ABR' },
    { name: 'MAI' },
    { name: 'JUN' },
    { name: 'JUL' },
    { name: 'AGO' },
    { name: 'SET' },
    { name: 'OUT' },
    { name: 'NOV' },
    { name: 'DEZ' }
  ]

  return values?.map((item: number, index: number) => ({
    power: item,
    ...months[index]
  }))
}
